import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'
import { ModalConfirm } from 'mailup-web-components'
import { modalConfirmCopy } from 'Pages/OverviewMessage/recoil/state/modal'
import { confirmCopyCallback } from 'Pages/OverviewMessage/recoil/callbacks/callbacks'
import { useHistory, useParams } from 'react-router-dom'

const ModalConfirmCopy = () => {
  const { id } = useParams()
  const history = useHistory()

  const intl = useIntl()
  const [open, setOpen] = useRecoilState(modalConfirmCopy)

  const handleClose = () => {
    setOpen(false)
  }

  const confirmCopy = useRecoilCallback(confirmCopyCallback, [])

  const handleConfirm = () => confirmCopy(id, false, history)

  return (
    <ModalConfirm
      show={open}
      closeOnOverlayClick={false}
      title={intl.formatMessage({
        id: 'Load.EmailMessageList.MessageConfirmCopyTitle'
      })}
      message={intl.formatMessage({
        id: 'Load.EmailMessageList.MessageConfirmCopy'
      })}
      onClickConfirm={handleConfirm}
      onClickCancel={handleClose}
      stringConfirm={intl.formatMessage({
        id: 'Load.MailupCommon.Yes'
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
    />
  )
}

export default ModalConfirmCopy
